import {OrderItem} from "./orderItem";
import {User} from "./user";
import {OrderVoucherItem} from "./orderVoucherItem";
import {VoucherTemplate} from "./voucherTemplate";
import {Product} from "./product";
import {Discount} from "../discount/model/discount";
import {OrderDiscount} from "./orderDiscount";

export class Order {
    id: string;
    uuid: string;
    items: OrderItem[] = [];
    vouchers: OrderVoucherItem[] = [];
    documentDate: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    deletedBy: string;
    createdBy: string;
    updatedBy: string;
    customer: User;
    description: string;
    priceGross: number = 0;
    worker: User;
    nip: string;
    companyName: string;
    companyStreet: string;
    companyPostCode: string;
    companyCity: string;
    companyCountry: string;
    paymentMethod?: string = 'gotówka';
    secondPaymentMethod?: string = null;
    secondPaymentMethodValue?: number = null;
    firstPaymentMethodValue?: number = null;
    isAssignedToCard: boolean;
    isOnlineOrder: boolean;
    assignedToCardAt: string;
    assignedToCardBy: string;
    priceGrossBeforeDiscount: number = 0;
    discountValue: number = 0;
    discounts: OrderDiscount[];
    virtualReceipt?: string = null;

    addVoucher(voucherTemplate: VoucherTemplate): void
    {
        let added = false;

        for (let i = 0; i < this.vouchers.length; i++) {
            if (this.vouchers[i].voucherTemplate !== voucherTemplate) {
                continue;
            }

            added = true;
            this.vouchers[i].quantity++;
        }

        if (!added) {
            let orderItem = new OrderVoucherItem();
            orderItem.quantity = 1;
            orderItem.priceGross = voucherTemplate.salePrice;
            orderItem.priceGrossBeforeDiscount = voucherTemplate.salePrice;
            if (voucherTemplate.vatRate) {
                orderItem.vatRate = voucherTemplate.vatRate.vatValue;
            }
            orderItem.voucherTemplate = voucherTemplate;

            this.vouchers.push(orderItem);
        }

        this.recalculateBill();
    }

    addProduct(product: Product): void {
        let added = false;

        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].product !== product) {
                continue;
            }

            added = true;
            this.items[i].quantity++;
        }

        if (!added) {
            let orderItem = new OrderItem();
            orderItem.quantity = 1;
            orderItem.priceGross = product.priceGross;
            orderItem.priceGrossBeforeDiscount = product.priceGross;
            if (product.vatRate) {
                orderItem.vatRate = product.vatRate.vatValue;
            }
            orderItem.product = product;
            if (product.unit) {
                orderItem.unit = product.unit.id;
            }

            this.items.push(orderItem);
        }

        this.recalculateBill();
    }

    recalculateBill(): void {
        this.priceGross = 0;
        this.priceGrossBeforeDiscount = 0;

        for (let i = 0; i < this.items.length; i++) {
            this.priceGross += (this.items[i].quantity * this.items[i].priceGross);
            this.priceGrossBeforeDiscount += (this.items[i].quantity * this.items[i].priceGrossBeforeDiscount);
        }

        for (let i = 0; i < this.vouchers.length; i++) {
            this.priceGross += (this.vouchers[i].quantity * this.vouchers[i].priceGross);
            this.priceGrossBeforeDiscount += (this.vouchers[i].quantity * this.vouchers[i].priceGrossBeforeDiscount);
        }
    }
}
